import React, { useState, useCallback, useMemo } from 'react'
import { Button } from '@cdm/quickenloans-library/lib';
import { TextField } from "@quickenloans-ui-suite/components/atomics"
import PropTypes from 'prop-types';
import * as yup from 'yup'
import img from './mockData/card-icon.png'
import * as styles from './EmailCapture.module.scss';
import { defaultAttributes, testAttributes } from './Constants';
import useFeatureFlag from '../../../utilities/featureFlag'

const emailSchema = yup.object().shape({
    email: yup
        .string()
        .email(defaultAttributes.textfieldError)
        .required(defaultAttributes.textfieldError),
});

const Success = () => (
    <div 
        className={`${styles.contentContainer}  ${styles.contentContainer__success}`} 
        data-testid={testAttributes.EMAIL_CAPTURE_SUCCESS_CONTAINER}
    >
        <div className={`${styles.textContainer}`}>
            <h2 data-testid={testAttributes.EMAIL_CAPTURE_SUCCESS_TITLE}>{defaultAttributes.successTitle}</h2>
            <p data-testid={testAttributes.EMAIL_CAPTURE_SUCCESS_DESCRIPTION}>{defaultAttributes.successDescription}</p>
        </div>
    </div>
);

const EmailCapture = ({ 
    title = defaultAttributes.title,
    description = defaultAttributes.description,
    buttonText = defaultAttributes.buttonText,
    altText = defaultAttributes.altText,
    clickHandler 
}) =>
{
    const hasFeatureFlag = useFeatureFlag(defaultAttributes.featureFlag);
    const [email, setEmail] = useState('')
    const [errorMsg, setErrorMsg] = useState('');
    const [isCTACompleted, setIsCTACompleted] = useState(false);

    const handleClick = useCallback(async () =>
    {
        try
        {
            await emailSchema.validate({ email });
            setErrorMsg('');
            clickHandler?.();
            setIsCTACompleted(true);
        }
        catch (err)
        {
            setErrorMsg(err.message);
            setIsCTACompleted(false);
        }
    }, [email, clickHandler]);

    const handleEmailChange = useCallback((e) =>
    {
        setEmail(e.target.value);
    }, []);

    const content = useMemo(() =>
    {
        if (isCTACompleted)
        {
            return <Success />;
        }
        
        return (
            <div 
                className={styles.contentContainer} 
                data-testid={testAttributes.EMAIL_CAPTURE_FORM_CONTAINER}
            >
                <div className={styles.textContainer}>
                    <h2 data-testid={testAttributes.EMAIL_CAPTURE_TITLE}>{title}</h2>
                    <p data-testid={testAttributes.EMAIL_CAPTURE_DESCRIPTION}>{description}</p>
                </div>
                <div className={styles.inputContainer}>
                    <TextField
                        helperText=""
                        errorText={errorMsg}
                        error={!!errorMsg}
                        label={defaultAttributes.placeholder}
                        textfieldClassName={styles.emailInput}
                        id={testAttributes.EMAIL_CAPTURE_INPUT}
                        data-testid={testAttributes.EMAIL_CAPTURE_INPUT}
                        onChange={handleEmailChange}
                        value={email}
                    />
                    <Button
                        color={defaultAttributes.color}
                        onClick={handleClick}
                        style={defaultAttributes.style}
                        className={styles.button}
                        testId={testAttributes.EMAIL_CAPTURE_BUTTON}
                    >
                        {buttonText}
                    </Button>
                </div>
            </div>
        );
    }, [isCTACompleted, title, description, errorMsg, email, handleEmailChange, handleClick, buttonText]);

    return (
        hasFeatureFlag?.enabled && (
            <div>
                <section 
                    className={styles.emailCapture__container}
                    data-testid={testAttributes.EMAIL_CAPTURE_CONTAINER}
                >
                    {content}
                    <img 
                        src={img} 
                        alt={altText} 
                        className={styles.featuredImage} 
                        data-testid={testAttributes.EMAIL_CAPTURE_IMAGE} 
                    />
                </section>
            </div>
        )
    );
};

export default EmailCapture;

EmailCapture.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    buttonText: PropTypes.string,
    altText: PropTypes.string,
    clickHandler: PropTypes.func,
};
